/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JoinRouteImport } from './routes/join'
import { Route as AuthConfirmRouteImport } from './routes/auth.confirm'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogPostIdRouteImport } from './routes/blog.$postId'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as CollectionsCollectionIdRouteImport } from './routes/collections.$collectionId'
import { Route as ComplianceIndexRouteImport } from './routes/compliance.index'
import { Route as CustomersIndexRouteImport } from './routes/customers.index'
import { Route as CustomersCustomerIdRouteImport } from './routes/customers.$customerId'
import { Route as DeliveriesIndexRouteImport } from './routes/deliveries.index'
import { Route as DeliveriesDeliveryIdRouteImport } from './routes/deliveries.$deliveryId'
import { Route as DesignsIndexRouteImport } from './routes/designs.index'
import { Route as DesignsSiteIdRouteImport } from './routes/designs.$siteId'
import { Route as DiscountsIndexRouteImport } from './routes/discounts.index'
import { Route as DiscountsDiscountIdRouteImport } from './routes/discounts.$discountId'
import { Route as GiftCardsIndexRouteImport } from './routes/gift-cards.index'
import { Route as GiftCardsCardIdRouteImport } from './routes/gift-cards.$cardId'
import { Route as InventoryIndexRouteImport } from './routes/inventory.index'
import { Route as InventoryItemIdRouteImport } from './routes/inventory.$itemId'
import { Route as LoyaltyIndexRouteImport } from './routes/loyalty.index'
import { Route as MarketingIndexRouteImport } from './routes/marketing.index'
import { Route as MediaIndexRouteImport } from './routes/media.index'
import { Route as MediaAssetIdRouteImport } from './routes/media.$assetId'
import { Route as MessagesIndexRouteImport } from './routes/messages.index'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as OrdersNewRouteImport } from './routes/orders.new'
import { Route as PackagesIndexRouteImport } from './routes/packages.index'
import { Route as PackagesPackageIdRouteImport } from './routes/packages.$packageId'
import { Route as PagesIndexRouteImport } from './routes/pages.index'
import { Route as PagesPageIdRouteImport } from './routes/pages.$pageId'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsProductIdRouteImport } from './routes/products.$productId'
import { Route as ProductsNewRouteImport } from './routes/products.new'
import { Route as QueueIndexRouteImport } from './routes/queue.index'
import { Route as TaxonomyIndexRouteImport } from './routes/taxonomy.index'
import { Route as TaxonomyTermIdRouteImport } from './routes/taxonomy.$termId'
import { Route as QueueRegisterEntryIdRouteImport } from './routes/queue.register.$entryId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfirmRoute = AuthConfirmRouteImport.update({
  id: '/auth/confirm',
  path: '/auth/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogPostIdRoute = BlogPostIdRouteImport.update({
  id: '/blog/$postId',
  path: '/blog/$postId',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsCollectionIdRoute = CollectionsCollectionIdRouteImport.update({
  id: '/collections/$collectionId',
  path: '/collections/$collectionId',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceIndexRoute = ComplianceIndexRouteImport.update({
  id: '/compliance/',
  path: '/compliance/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersCustomerIdRoute = CustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveriesIndexRoute = DeliveriesIndexRouteImport.update({
  id: '/deliveries/',
  path: '/deliveries/',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveriesDeliveryIdRoute = DeliveriesDeliveryIdRouteImport.update({
  id: '/deliveries/$deliveryId',
  path: '/deliveries/$deliveryId',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignsIndexRoute = DesignsIndexRouteImport.update({
  id: '/designs/',
  path: '/designs/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignsSiteIdRoute = DesignsSiteIdRouteImport.update({
  id: '/designs/$siteId',
  path: '/designs/$siteId',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscountsIndexRoute = DiscountsIndexRouteImport.update({
  id: '/discounts/',
  path: '/discounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscountsDiscountIdRoute = DiscountsDiscountIdRouteImport.update({
  id: '/discounts/$discountId',
  path: '/discounts/$discountId',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftCardsIndexRoute = GiftCardsIndexRouteImport.update({
  id: '/gift-cards/',
  path: '/gift-cards/',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftCardsCardIdRoute = GiftCardsCardIdRouteImport.update({
  id: '/gift-cards/$cardId',
  path: '/gift-cards/$cardId',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryIndexRoute = InventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryItemIdRoute = InventoryItemIdRouteImport.update({
  id: '/inventory/$itemId',
  path: '/inventory/$itemId',
  getParentRoute: () => rootRouteImport,
} as any)
const LoyaltyIndexRoute = LoyaltyIndexRouteImport.update({
  id: '/loyalty/',
  path: '/loyalty/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/marketing/',
  path: '/marketing/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaIndexRoute = MediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaAssetIdRoute = MediaAssetIdRouteImport.update({
  id: '/media/$assetId',
  path: '/media/$assetId',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersNewRoute = OrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesIndexRoute = PackagesIndexRouteImport.update({
  id: '/packages/',
  path: '/packages/',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesPackageIdRoute = PackagesPackageIdRouteImport.update({
  id: '/packages/$packageId',
  path: '/packages/$packageId',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesIndexRoute = PagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => rootRouteImport,
} as any)
const PagesPageIdRoute = PagesPageIdRouteImport.update({
  id: '/pages/$pageId',
  path: '/pages/$pageId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsNewRoute = ProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => rootRouteImport,
} as any)
const QueueIndexRoute = QueueIndexRouteImport.update({
  id: '/queue/',
  path: '/queue/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxonomyIndexRoute = TaxonomyIndexRouteImport.update({
  id: '/taxonomy/',
  path: '/taxonomy/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxonomyTermIdRoute = TaxonomyTermIdRouteImport.update({
  id: '/taxonomy/$termId',
  path: '/taxonomy/$termId',
  getParentRoute: () => rootRouteImport,
} as any)
const QueueRegisterEntryIdRoute = QueueRegisterEntryIdRouteImport.update({
  id: '/queue/register/$entryId',
  path: '/queue/register/$entryId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/designs/$siteId': typeof DesignsSiteIdRoute
  '/discounts/$discountId': typeof DiscountsDiscountIdRoute
  '/gift-cards/$cardId': typeof GiftCardsCardIdRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/media/$assetId': typeof MediaAssetIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/packages/$packageId': typeof PackagesPackageIdRoute
  '/pages/$pageId': typeof PagesPageIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/taxonomy/$termId': typeof TaxonomyTermIdRoute
  '/blog/': typeof BlogIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/deliveries/': typeof DeliveriesIndexRoute
  '/designs/': typeof DesignsIndexRoute
  '/discounts/': typeof DiscountsIndexRoute
  '/gift-cards/': typeof GiftCardsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/loyalty/': typeof LoyaltyIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/media/': typeof MediaIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/packages/': typeof PackagesIndexRoute
  '/pages/': typeof PagesIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/queue/': typeof QueueIndexRoute
  '/taxonomy/': typeof TaxonomyIndexRoute
  '/queue/register/$entryId': typeof QueueRegisterEntryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/designs/$siteId': typeof DesignsSiteIdRoute
  '/discounts/$discountId': typeof DiscountsDiscountIdRoute
  '/gift-cards/$cardId': typeof GiftCardsCardIdRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/media/$assetId': typeof MediaAssetIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/packages/$packageId': typeof PackagesPackageIdRoute
  '/pages/$pageId': typeof PagesPageIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/taxonomy/$termId': typeof TaxonomyTermIdRoute
  '/blog': typeof BlogIndexRoute
  '/collections': typeof CollectionsIndexRoute
  '/compliance': typeof ComplianceIndexRoute
  '/customers': typeof CustomersIndexRoute
  '/deliveries': typeof DeliveriesIndexRoute
  '/designs': typeof DesignsIndexRoute
  '/discounts': typeof DiscountsIndexRoute
  '/gift-cards': typeof GiftCardsIndexRoute
  '/inventory': typeof InventoryIndexRoute
  '/loyalty': typeof LoyaltyIndexRoute
  '/marketing': typeof MarketingIndexRoute
  '/media': typeof MediaIndexRoute
  '/messages': typeof MessagesIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/packages': typeof PackagesIndexRoute
  '/pages': typeof PagesIndexRoute
  '/products': typeof ProductsIndexRoute
  '/queue': typeof QueueIndexRoute
  '/taxonomy': typeof TaxonomyIndexRoute
  '/queue/register/$entryId': typeof QueueRegisterEntryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/blog/$postId': typeof BlogPostIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/customers/$customerId': typeof CustomersCustomerIdRoute
  '/deliveries/$deliveryId': typeof DeliveriesDeliveryIdRoute
  '/designs/$siteId': typeof DesignsSiteIdRoute
  '/discounts/$discountId': typeof DiscountsDiscountIdRoute
  '/gift-cards/$cardId': typeof GiftCardsCardIdRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/media/$assetId': typeof MediaAssetIdRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/packages/$packageId': typeof PackagesPackageIdRoute
  '/pages/$pageId': typeof PagesPageIdRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/taxonomy/$termId': typeof TaxonomyTermIdRoute
  '/blog/': typeof BlogIndexRoute
  '/collections/': typeof CollectionsIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/deliveries/': typeof DeliveriesIndexRoute
  '/designs/': typeof DesignsIndexRoute
  '/discounts/': typeof DiscountsIndexRoute
  '/gift-cards/': typeof GiftCardsIndexRoute
  '/inventory/': typeof InventoryIndexRoute
  '/loyalty/': typeof LoyaltyIndexRoute
  '/marketing/': typeof MarketingIndexRoute
  '/media/': typeof MediaIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/packages/': typeof PackagesIndexRoute
  '/pages/': typeof PagesIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/queue/': typeof QueueIndexRoute
  '/taxonomy/': typeof TaxonomyIndexRoute
  '/queue/register/$entryId': typeof QueueRegisterEntryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/auth/confirm'
    | '/blog/$postId'
    | '/collections/$collectionId'
    | '/customers/$customerId'
    | '/deliveries/$deliveryId'
    | '/designs/$siteId'
    | '/discounts/$discountId'
    | '/gift-cards/$cardId'
    | '/inventory/$itemId'
    | '/media/$assetId'
    | '/orders/$orderId'
    | '/orders/new'
    | '/packages/$packageId'
    | '/pages/$pageId'
    | '/products/$productId'
    | '/products/new'
    | '/taxonomy/$termId'
    | '/blog/'
    | '/collections/'
    | '/compliance/'
    | '/customers/'
    | '/deliveries/'
    | '/designs/'
    | '/discounts/'
    | '/gift-cards/'
    | '/inventory/'
    | '/loyalty/'
    | '/marketing/'
    | '/media/'
    | '/messages/'
    | '/orders/'
    | '/packages/'
    | '/pages/'
    | '/products/'
    | '/queue/'
    | '/taxonomy/'
    | '/queue/register/$entryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/auth/confirm'
    | '/blog/$postId'
    | '/collections/$collectionId'
    | '/customers/$customerId'
    | '/deliveries/$deliveryId'
    | '/designs/$siteId'
    | '/discounts/$discountId'
    | '/gift-cards/$cardId'
    | '/inventory/$itemId'
    | '/media/$assetId'
    | '/orders/$orderId'
    | '/orders/new'
    | '/packages/$packageId'
    | '/pages/$pageId'
    | '/products/$productId'
    | '/products/new'
    | '/taxonomy/$termId'
    | '/blog'
    | '/collections'
    | '/compliance'
    | '/customers'
    | '/deliveries'
    | '/designs'
    | '/discounts'
    | '/gift-cards'
    | '/inventory'
    | '/loyalty'
    | '/marketing'
    | '/media'
    | '/messages'
    | '/orders'
    | '/packages'
    | '/pages'
    | '/products'
    | '/queue'
    | '/taxonomy'
    | '/queue/register/$entryId'
  id:
    | '__root__'
    | '/'
    | '/join'
    | '/auth/confirm'
    | '/blog/$postId'
    | '/collections/$collectionId'
    | '/customers/$customerId'
    | '/deliveries/$deliveryId'
    | '/designs/$siteId'
    | '/discounts/$discountId'
    | '/gift-cards/$cardId'
    | '/inventory/$itemId'
    | '/media/$assetId'
    | '/orders/$orderId'
    | '/orders/new'
    | '/packages/$packageId'
    | '/pages/$pageId'
    | '/products/$productId'
    | '/products/new'
    | '/taxonomy/$termId'
    | '/blog/'
    | '/collections/'
    | '/compliance/'
    | '/customers/'
    | '/deliveries/'
    | '/designs/'
    | '/discounts/'
    | '/gift-cards/'
    | '/inventory/'
    | '/loyalty/'
    | '/marketing/'
    | '/media/'
    | '/messages/'
    | '/orders/'
    | '/packages/'
    | '/pages/'
    | '/products/'
    | '/queue/'
    | '/taxonomy/'
    | '/queue/register/$entryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JoinRoute: typeof JoinRoute
  AuthConfirmRoute: typeof AuthConfirmRoute
  BlogPostIdRoute: typeof BlogPostIdRoute
  CollectionsCollectionIdRoute: typeof CollectionsCollectionIdRoute
  CustomersCustomerIdRoute: typeof CustomersCustomerIdRoute
  DeliveriesDeliveryIdRoute: typeof DeliveriesDeliveryIdRoute
  DesignsSiteIdRoute: typeof DesignsSiteIdRoute
  DiscountsDiscountIdRoute: typeof DiscountsDiscountIdRoute
  GiftCardsCardIdRoute: typeof GiftCardsCardIdRoute
  InventoryItemIdRoute: typeof InventoryItemIdRoute
  MediaAssetIdRoute: typeof MediaAssetIdRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  OrdersNewRoute: typeof OrdersNewRoute
  PackagesPackageIdRoute: typeof PackagesPackageIdRoute
  PagesPageIdRoute: typeof PagesPageIdRoute
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsNewRoute: typeof ProductsNewRoute
  TaxonomyTermIdRoute: typeof TaxonomyTermIdRoute
  BlogIndexRoute: typeof BlogIndexRoute
  CollectionsIndexRoute: typeof CollectionsIndexRoute
  ComplianceIndexRoute: typeof ComplianceIndexRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  DeliveriesIndexRoute: typeof DeliveriesIndexRoute
  DesignsIndexRoute: typeof DesignsIndexRoute
  DiscountsIndexRoute: typeof DiscountsIndexRoute
  GiftCardsIndexRoute: typeof GiftCardsIndexRoute
  InventoryIndexRoute: typeof InventoryIndexRoute
  LoyaltyIndexRoute: typeof LoyaltyIndexRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MediaIndexRoute: typeof MediaIndexRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  PackagesIndexRoute: typeof PackagesIndexRoute
  PagesIndexRoute: typeof PagesIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  QueueIndexRoute: typeof QueueIndexRoute
  TaxonomyIndexRoute: typeof TaxonomyIndexRoute
  QueueRegisterEntryIdRoute: typeof QueueRegisterEntryIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/confirm': {
      id: '/auth/confirm'
      path: '/auth/confirm'
      fullPath: '/auth/confirm'
      preLoaderRoute: typeof AuthConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$postId': {
      id: '/blog/$postId'
      path: '/blog/$postId'
      fullPath: '/blog/$postId'
      preLoaderRoute: typeof BlogPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/': {
      id: '/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof CollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/$collectionId': {
      id: '/collections/$collectionId'
      path: '/collections/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof CollectionsCollectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance/': {
      id: '/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof ComplianceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId': {
      id: '/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof CustomersCustomerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deliveries/': {
      id: '/deliveries/'
      path: '/deliveries'
      fullPath: '/deliveries/'
      preLoaderRoute: typeof DeliveriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deliveries/$deliveryId': {
      id: '/deliveries/$deliveryId'
      path: '/deliveries/$deliveryId'
      fullPath: '/deliveries/$deliveryId'
      preLoaderRoute: typeof DeliveriesDeliveryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/designs/': {
      id: '/designs/'
      path: '/designs'
      fullPath: '/designs/'
      preLoaderRoute: typeof DesignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/designs/$siteId': {
      id: '/designs/$siteId'
      path: '/designs/$siteId'
      fullPath: '/designs/$siteId'
      preLoaderRoute: typeof DesignsSiteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discounts/': {
      id: '/discounts/'
      path: '/discounts'
      fullPath: '/discounts/'
      preLoaderRoute: typeof DiscountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discounts/$discountId': {
      id: '/discounts/$discountId'
      path: '/discounts/$discountId'
      fullPath: '/discounts/$discountId'
      preLoaderRoute: typeof DiscountsDiscountIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards/': {
      id: '/gift-cards/'
      path: '/gift-cards'
      fullPath: '/gift-cards/'
      preLoaderRoute: typeof GiftCardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards/$cardId': {
      id: '/gift-cards/$cardId'
      path: '/gift-cards/$cardId'
      fullPath: '/gift-cards/$cardId'
      preLoaderRoute: typeof GiftCardsCardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/': {
      id: '/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof InventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/$itemId': {
      id: '/inventory/$itemId'
      path: '/inventory/$itemId'
      fullPath: '/inventory/$itemId'
      preLoaderRoute: typeof InventoryItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loyalty/': {
      id: '/loyalty/'
      path: '/loyalty'
      fullPath: '/loyalty/'
      preLoaderRoute: typeof LoyaltyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketing/': {
      id: '/marketing/'
      path: '/marketing'
      fullPath: '/marketing/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/': {
      id: '/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof MediaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/$assetId': {
      id: '/media/$assetId'
      path: '/media/$assetId'
      fullPath: '/media/$assetId'
      preLoaderRoute: typeof MediaAssetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/': {
      id: '/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/new': {
      id: '/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof OrdersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages/': {
      id: '/packages/'
      path: '/packages'
      fullPath: '/packages/'
      preLoaderRoute: typeof PackagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages/$packageId': {
      id: '/packages/$packageId'
      path: '/packages/$packageId'
      fullPath: '/packages/$packageId'
      preLoaderRoute: typeof PackagesPackageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/': {
      id: '/pages/'
      path: '/pages'
      fullPath: '/pages/'
      preLoaderRoute: typeof PagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pages/$pageId': {
      id: '/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/pages/$pageId'
      preLoaderRoute: typeof PagesPageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/new': {
      id: '/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof ProductsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queue/': {
      id: '/queue/'
      path: '/queue'
      fullPath: '/queue/'
      preLoaderRoute: typeof QueueIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxonomy/': {
      id: '/taxonomy/'
      path: '/taxonomy'
      fullPath: '/taxonomy/'
      preLoaderRoute: typeof TaxonomyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxonomy/$termId': {
      id: '/taxonomy/$termId'
      path: '/taxonomy/$termId'
      fullPath: '/taxonomy/$termId'
      preLoaderRoute: typeof TaxonomyTermIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queue/register/$entryId': {
      id: '/queue/register/$entryId'
      path: '/queue/register/$entryId'
      fullPath: '/queue/register/$entryId'
      preLoaderRoute: typeof QueueRegisterEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JoinRoute: JoinRoute,
  AuthConfirmRoute: AuthConfirmRoute,
  BlogPostIdRoute: BlogPostIdRoute,
  CollectionsCollectionIdRoute: CollectionsCollectionIdRoute,
  CustomersCustomerIdRoute: CustomersCustomerIdRoute,
  DeliveriesDeliveryIdRoute: DeliveriesDeliveryIdRoute,
  DesignsSiteIdRoute: DesignsSiteIdRoute,
  DiscountsDiscountIdRoute: DiscountsDiscountIdRoute,
  GiftCardsCardIdRoute: GiftCardsCardIdRoute,
  InventoryItemIdRoute: InventoryItemIdRoute,
  MediaAssetIdRoute: MediaAssetIdRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  OrdersNewRoute: OrdersNewRoute,
  PackagesPackageIdRoute: PackagesPackageIdRoute,
  PagesPageIdRoute: PagesPageIdRoute,
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsNewRoute: ProductsNewRoute,
  TaxonomyTermIdRoute: TaxonomyTermIdRoute,
  BlogIndexRoute: BlogIndexRoute,
  CollectionsIndexRoute: CollectionsIndexRoute,
  ComplianceIndexRoute: ComplianceIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  DeliveriesIndexRoute: DeliveriesIndexRoute,
  DesignsIndexRoute: DesignsIndexRoute,
  DiscountsIndexRoute: DiscountsIndexRoute,
  GiftCardsIndexRoute: GiftCardsIndexRoute,
  InventoryIndexRoute: InventoryIndexRoute,
  LoyaltyIndexRoute: LoyaltyIndexRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MediaIndexRoute: MediaIndexRoute,
  MessagesIndexRoute: MessagesIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  PackagesIndexRoute: PackagesIndexRoute,
  PagesIndexRoute: PagesIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  QueueIndexRoute: QueueIndexRoute,
  TaxonomyIndexRoute: TaxonomyIndexRoute,
  QueueRegisterEntryIdRoute: QueueRegisterEntryIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
